import type {
	Product,
	ProductForCustomer,
	ProductOfVariant,
	ProductOfVariantForCustomer,
	ProductVariant,
} from "../Product.js";

export function getProductOfVariant(product: Product, variantId: ProductVariant["id"]): ProductOfVariant;
export function getProductOfVariant(
	product: ProductForCustomer,
	variantId: ProductVariant["id"],
): ProductOfVariantForCustomer;
export function getProductOfVariant<TProduct extends Product | ProductForCustomer>(
	product: TProduct,
	variantId: ProductVariant["id"],
): TProduct & { variant: TProduct["variants"][number] } {
	const variant = product.variants.find(({ id }) => id === variantId);
	if (!variant) {
		throw new Error(`Could not find variant with ID: ${variantId}`);
	}
	return { ...product, variant };
}
